import './SearchResultsList.css';
import React, { useEffect, useRef, useState } from 'react';
import ListingItem from '../ListingItem';
import { getItemColor } from '../../utils/getItemColor';
import { paginate } from '../../utils/paginate';
import { moveObjectToFirstPlace } from '../../../../114_InteractiveMap/InteractiveMap';
const SearchResultsList = _ref => {
  let {
    params,
    hits,
    analytics,
    defaultTypeValues,
    activeListingItemId,
    rtl,
    getActivePopupOnMap,
    activeTopPicks,
    toggleActiveTopPicks,
    mainHitsPerPage,
    query
  } = _ref;
  const [items, setItems] = useState([]);
  const loaderRef = useRef(null);
  const canBeMoreLoaded = useRef(true);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  React.useEffect(() => {
    setItems(paginate(hits, Number(mainHitsPerPage), 1));
  }, [hits]);
  React.useEffect(() => {
    canBeMoreLoaded.current = false;
    if (activeListingItemId) {
      setPage(1);
      const updatedListingHits = moveObjectToFirstPlace(hits, hit => hit.objectID === activeListingItemId);
      setItems(paginate(updatedListingHits, Number(mainHitsPerPage), 1));
      setTimeout(() => {
        canBeMoreLoaded.current = true;
      }, 2000);
    }
  }, [activeListingItemId]);
  const fetchData = () => {
    if (isLoading) return;
    const itemsToCompare = hits;
    const newData = paginate(itemsToCompare, Number(mainHitsPerPage), page + 1);
    setItems([...items, ...newData]);
    setIsLoading(false);
    setPage(prevIndex => prevIndex + 1);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const target = entries[0];
      if (target.isIntersecting) {
        const itemsToCompare = hits;
        if (items.length !== itemsToCompare.length) {
          if (canBeMoreLoaded.current) {
            fetchData();
          } else {
            setPage(1);
          }
        }
      }
    });
    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [fetchData]);
  const renderItems = () => {
    if (items && items.length) {
      return items.map((hit, index) => /*#__PURE__*/React.createElement(ListingItem, {
        rtl: rtl,
        key: `${hit.objectID}`,
        item: hit,
        isActiveItem: activeListingItemId === hit.objectID,
        color: getItemColor(hit, defaultTypeValues),
        isCarousel: false,
        analytics: analytics,
        params: params,
        getActivePopupOnMap: getActivePopupOnMap,
        activeTopPicks: activeTopPicks,
        toggleActiveTopPicks: toggleActiveTopPicks,
        withHighlightText: true,
        searchString: query
      }));
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: ``
  }, /*#__PURE__*/React.createElement("ul", {
    className: "results-list"
  }, renderItems(), /*#__PURE__*/React.createElement("div", {
    ref: loaderRef,
    style: {
      paddingBottom: '50px'
    }
  }))));
};
export default SearchResultsList;
const StyledContainer = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c170ga2w";
const ltrStyles = "lq25x3l";
const rtlStyles = "rapa45w";